export default "__VITE_ASSET__W_vtnA_b__"